export const MMAXIMUM_DISTANCE_SEARCH_SPACES = 2000;

